
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.396 11.677a1.135 1.135 0 001.605 0l2.982-2.982a1.135 1.135 0 000-1.605L12 4.109a1.135 1.135 0 10-1.605 1.605l1.043 1.043H1.605a1.135 1.135 0 000 2.27h9.834l-1.043 1.044a1.135 1.135 0 000 1.606z","fill":"currentColor"}})])
          )
        }
      }
    